import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=493f09ac&scoped=true"
import script from "./ExamResult.vue?vue&type=script&lang=js"
export * from "./ExamResult.vue?vue&type=script&lang=js"
import style0 from "./ExamResult.vue?vue&type=style&index=0&id=493f09ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f09ac",
  null
  
)

export default component.exports